import { render, staticRenderFns } from "./PublicHolidayGroup.vue?vue&type=template&id=2606c00a&scoped=true&"
import script from "./PublicHolidayGroup.vue?vue&type=script&lang=js&"
export * from "./PublicHolidayGroup.vue?vue&type=script&lang=js&"
import style0 from "./PublicHolidayGroup.vue?vue&type=style&index=0&id=2606c00a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2606c00a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Mega\\MRC\\mrc-ess-fronted\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2606c00a')) {
      api.createRecord('2606c00a', component.options)
    } else {
      api.reload('2606c00a', component.options)
    }
    module.hot.accept("./PublicHolidayGroup.vue?vue&type=template&id=2606c00a&scoped=true&", function () {
      api.rerender('2606c00a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Page/EssAdmin/Holiday/PublicHolidayGroup/PublicHolidayGroup.vue"
export default component.exports